import * as Dialog from "@radix-ui/react-dialog";

import closeSvg from "../../img/close.svg";
import contentCollapseSvg from "../../img/content-collapse.svg";
import contentExpandSvg from "../../img/content-expand.svg";
import { Svg } from "../../utils/svgIcon";
import { AiMagicSparkles } from "../AiMagicSparkles";
import { InfoTooltip } from "../InfoTooltip";

import * as styles from "./AiHeader.css";

interface AiHeaderProps {
    title: string;
    infoTooltipText: string;
    expanded: boolean;
    onExpandedChange: (expanded: boolean) => void;
    resizeAriaLabel?: string;
    onClose: () => void;
    closeAriaLabel?: string;
    betaLabel?: string;
}
export function AiHeader({
    title,
    infoTooltipText,
    expanded,
    onExpandedChange,
    onClose,
    closeAriaLabel,
    resizeAriaLabel,
    betaLabel,
}: AiHeaderProps) {
    const onClick = () => onExpandedChange(!expanded);

    return (
        <div className={styles.aiHeaderContainer}>
            <div className={styles.aiHeaderTextContainer}>
                <AiMagicSparkles size={18} />
                <Dialog.Title className={styles.aiHeaderText}>
                    {title}
                </Dialog.Title>
                {betaLabel && (
                    <sup className={styles.betaLabel}>{betaLabel}</sup>
                )}
                <InfoTooltip
                    text={infoTooltipText}
                    size="small"
                    className={styles.infoTooltip}
                />
            </div>
            <div className={styles.buttonContainer}>
                <ResizeButton
                    expanded={expanded}
                    onClick={onClick}
                    ariaLabel={resizeAriaLabel}
                />
                <button
                    className={styles.button}
                    onClick={onClose}
                    aria-label={closeAriaLabel}
                    data-pendo="ai-drawer-close"
                >
                    <Svg src={closeSvg} />
                </button>
            </div>
        </div>
    );
}

interface ResizeButtonProps {
    expanded: boolean;
    onClick: () => void;
    ariaLabel?: string;
}

function ResizeButton({ expanded, onClick, ariaLabel }: ResizeButtonProps) {
    return (
        <button
            className={styles.button}
            onClick={onClick}
            aria-label={ariaLabel}
        >
            <span className={styles.resizeIcon} data-visible={!expanded}>
                <Svg src={contentExpandSvg} />
            </span>
            <span className={styles.resizeIcon} data-visible={expanded}>
                <Svg src={contentCollapseSvg} />
            </span>
        </button>
    );
}
